import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-assistant-loader',
  templateUrl: './assistant-loader.component.html',
  styleUrls: ['./assistant-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AssistantLoaderComponent {
  @Input() loaderMessage: string = '';
}
